import {Component, OnInit, inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {Router, NavigationEnd, ActivatedRoute, Data} from '@angular/router';
import {filter, map, mergeMap} from 'rxjs/operators';
import {TablerIconsModule} from 'angular-tabler-icons';
import {environment} from '@environment/environment';

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterModule, TablerIconsModule],
  standalone: true,
  templateUrl: './breadcrumb.component.html',
  styleUrls: [],
})
export class AppBreadcrumbComponent {
  // @Input() layout;
  private router: Router = inject(Router);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private titleService: Title = inject(Title);
  private translate: TranslateService = inject(TranslateService);

  pageInfo: Data | any = Object.create(null);
  myurl: any = this.router.url.slice(1).split('/');

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        this.pageInfo = event;
        this.updateTitle();
      });
    this.translate.onLangChange.subscribe(() => this.updateTitle());
  }

  // data.titleKey is translated in the language of the panel; routes without it keep their fixed title
  private updateTitle(): void {
    const key = this.pageInfo?.['titleKey'];
    if (!key) {
      this.titleService.setTitle(this.pageInfo?.['title'] + environment.second_title);
      return;
    }
    this.translate.get(key).subscribe(title => this.titleService.setTitle(title + environment.second_title));
  }
}
